function SuccessIcon() {
    return (
        <div className="flex justify-start items-start flex-grow-0 flex-shrink-0 absolute gap-2">
            <svg
                width={24}
                height={25}
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="flex-grow-0 flex-shrink-0 w-6 h-6 relative"
                preserveAspectRatio="xMidYMid meet"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 20.4141C16.4183 20.4141 20 16.8323 20 12.4141C20 7.99578 16.4183 4.41406 12 4.41406C7.58172 4.41406 4 7.99578 4 12.4141C4 16.8323 7.58172 20.4141 12 20.4141ZM12 22.4141C17.5228 22.4141 22 17.9369 22 12.4141C22 6.89121 17.5228 2.41406 12 2.41406C6.47715 2.41406 2 6.89121 2 12.4141C2 17.9369 6.47715 22.4141 12 22.4141Z"
                    fill="#34C759"
                />
                <path
                    d="M6.6145 13.5873L7.95086 12.0952L10.7731 14.9174L16.3504 8.49025L17.8508 9.81071L10.886 17.8588L6.6145 13.5873Z"
                    fill="#34C759"
                />
            </svg>
        </div>
    )
}

export default SuccessIcon;
